import React, {useEffect, useState} from 'react'
import {Box, Grid, Typography} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {getMerchant} from '../../../helpers/ReduxHelpers'
import {get, apiConstants} from '../../../common/constants'
import {FONT, SIZE, WEIGHT} from '../../../styles/foundation/typography'
import {NAVY, SUBTLE, BORDER, LIGHT_BG, PRIMARY_BLUE} from '../../../styles/foundation/colors'
import {helpTextSx, helpTextTypeSx} from '../../../styles/patterns'

// Company Profile is tied to KYC and managed by Prozo — presented read-only.
const cellSx = {bgcolor: LIGHT_BG, border: `1px solid ${BORDER}`, borderRadius: '10px', p: '12px 14px', height: '100%'}

export default function MerchantDetails() {
  const merchant = getMerchant()
  const merchantId = merchant?.id || ''
  const [info, setInfo] = useState({name: '', email: '', contact: ''})

  useEffect(() => {
    if (!merchantId) return
    get(`${apiConstants.BASE_LOCAL}${apiConstants.GET_MERCHANT}/${merchantId}`)
      .then((res) => setInfo({
        name: res.data?.name || '',
        email: res.data?.email || '',
        contact: res.data?.contact_no || '',
      }))
      .catch((err) => console.error(err))
  }, [merchantId])

  const fields = [
    {label: 'Company Name', value: info.name},
    {label: 'Email Address', value: info.email},
    {label: 'Contact Number', value: info.contact},
  ]

  return (
    <Box>
      <Grid container spacing={2}>
        {fields.map((f) => (
          <Grid item xs={12} md={6} key={f.label}>
            <Box sx={cellSx}>
              <Typography sx={{fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, mb: 0.4, textTransform: 'uppercase', letterSpacing: '0.03em'}}>
                {f.label}
              </Typography>
              <Typography sx={{fontFamily: FONT, fontSize: SIZE.sm, fontWeight: WEIGHT.semibold, color: NAVY, wordBreak: 'break-word'}}>
                {f.value || '—'}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box sx={{...helpTextSx, mt: 2}}>
        <InfoOutlinedIcon sx={{fontSize: 16, color: PRIMARY_BLUE, mt: 0.2}} />
        <Typography sx={helpTextTypeSx}>
          These details are tied to your KYC and managed by Prozo. To change them, please contact support.
        </Typography>
      </Box>
    </Box>
  )
}
